import classnames from 'classnames'
import { RefinementListProvided } from 'react-instantsearch-core'
import Checkbox, { CheckboxProps } from '../../../control-components/ui-components/Checkbox'
import Phrase from '../../../libs/translationsUtils/phrase'
import Count from './ResultsCount'

export interface RefinedTypesContentProps extends RefinementListProvided {
  labelExtractor: (label: string) => CheckboxProps['label']
}

export const RefinedTypesContent = (props: RefinedTypesContentProps) => {
  const { labelExtractor, items, refine } = props
  if (items.length === 0) {
    return (
      <div class='instant-search__filter-no-results'>
        <Phrase p='No results' m='Control' />
      </div>
    )
  }
  return (
    <ul>
      {items.map((item) => (
        <li key={item.label} className='instant-search__filter-list-item'>
          <div
            className={classnames('instant-search-filter__label-wrapper', {
              refined: item.isRefined
            })}
          >
            <Checkbox
              label={labelExtractor(item.label)}
              onUpdate={() => refine(item.value)}
              qaClasses='topic-type-checkbox'
              checked={item.isRefined}
            />
            <Count count={item.count} />
          </div>
        </li>
      ))}
    </ul>
  )
}
